/** Footer info & keyboard tips */
export function PaletteFooter() {
  return (
    <footer className="flex items-center justify-between border-t border-zinc-800/80 bg-zinc-900/40 px-4 py-2.5 text-[11px] text-zinc-500">
      <div className="flex items-center gap-3">
        <span className="flex items-center gap-1">
          <kbd className="rounded border border-zinc-700 bg-zinc-800 px-1 py-0.5 font-mono text-[9px]">
            ↑
          </kbd>
          <kbd className="rounded border border-zinc-700 bg-zinc-800 px-1 py-0.5 font-mono text-[9px]">
            ↓
          </kbd>
          Navigate
        </span>
        <span className="flex items-center gap-1">
          <kbd className="rounded border border-zinc-700 bg-zinc-800 px-1 py-0.5 font-mono text-[9px]">
            ↵
          </kbd>
          Select
        </span>
        <span className="flex items-center gap-1">
          <kbd className="rounded border border-zinc-700 bg-zinc-800 px-1 py-0.5 font-mono text-[9px]">
            esc
          </kbd>
          Close
        </span>
      </div>
      <div>
        <span className="text-zinc-600">Command Palette</span>
      </div>
    </footer>
  );
}
